import localizationStrings from "./localization";

const copy = {
  eng: {
    live: "Live TV",
    liveNote: "Your channels. Your front-row seat.",
    onAir: "ON AIR",
    guide: "TV guide",
    guideNote: "Find your moment. Plan your next watch.",
    guideEyebrow: "THE ATLAS GUIDE",
    channels: "Channels",
    search: "Find a channel",
    clear: "Clear search",
    category: "Category",
    all: "All channels",
    favorites: "Favourites",
    noChannels: "No channels match your search.",
    now: "Now",
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    schedule: "On this channel",
    watch: "Watch live",
    later: "Later",
    earlier: "Earlier",
    more: "More channels",
    noPrograms: "No schedule available for this day.",
    loading: "Loading the schedule…",
    error: "We couldn't load the schedule.",
    retry: "Try again",
    channelError: "We couldn't load the channels.",
    hint: "Select a programme for details and viewing options.",
    backLive: "Back to live",
    playError: "We couldn't start this programme. Please try again.",
    liveBadge: "LIVE",
    day: "Broadcast day",
    current: "On now",
    upcoming: "Up next",
    restart: "Start over"
  },
  tr: {
    live: "Canlı TV",
    liveNote: "Sevdiğin kanallar. En ön sırada sen.",
    onAir: "ŞİMDİ YAYINDA",
    guide: "TV rehberi",
    guideNote: "Anı yakala. Sıradaki izleyeceğini keşfet.",
    guideEyebrow: "ATLAS YAYIN REHBERİ",
    channels: "Kanallar",
    search: "Kanal ara",
    clear: "Aramayı temizle",
    category: "Kategori",
    all: "Tüm kanallar",
    favorites: "Favoriler",
    noChannels: "Aramana uygun kanal bulunamadı.",
    now: "Şimdi",
    today: "Bugün",
    yesterday: "Dün",
    tomorrow: "Yarın",
    schedule: "Bu kanalda",
    watch: "Canlı izle",
    later: "Sonraki saatler",
    earlier: "Önceki saatler",
    more: "Daha fazla kanal",
    noPrograms: "Bu güne ait yayın akışı bulunmuyor.",
    loading: "Yayın akışı yükleniyor…",
    error: "Yayın akışı yüklenemedi.",
    retry: "Tekrar dene",
    channelError: "Kanallar yüklenemedi.",
    hint: "Detaylar ve izleme seçenekleri için bir program seç.",
    backLive: "Canlıya dön",
    playError: "Program başlatılamadı. Lütfen tekrar dene.",
    liveBadge: "CANLI",
    day: "Yayın günü",
    current: "Şimdi yayında",
    upcoming: "Sıradaki",
    restart: "Baştan izle"
  },
  arb: {
    live: "البث المباشر",
    liveNote: "قنواتك المفضلة في الصف الأمامي.",
    onAir: "على الهواء",
    guide: "دليل التلفزيون",
    guideNote: "اكتشف ما يُعرض وخطط لمشاهدتك التالية.",
    guideEyebrow: "دليل أطلس",
    channels: "القنوات",
    search: "ابحث عن قناة",
    clear: "مسح البحث",
    category: "الفئة",
    all: "كل القنوات",
    favorites: "المفضلة",
    noChannels: "لا توجد قنوات مطابقة.",
    now: "الآن",
    today: "اليوم",
    yesterday: "أمس",
    tomorrow: "غداً",
    schedule: "على هذه القناة",
    watch: "شاهد مباشرة",
    later: "لاحقاً",
    earlier: "سابقاً",
    more: "المزيد من القنوات",
    noPrograms: "لا يتوفر جدول لهذا اليوم.",
    loading: "جارٍ تحميل الجدول…",
    error: "تعذر تحميل الجدول.",
    retry: "حاول مجدداً",
    channelError: "تعذر تحميل القنوات.",
    hint: "اختر برنامجاً للتفاصيل وخيارات المشاهدة.",
    backLive: "العودة للبث",
    playError: "تعذر بدء البرنامج. حاول مرة أخرى.",
    liveBadge: "مباشر",
    day: "يوم البث",
    current: "يُعرض الآن",
    upcoming: "التالي",
    restart: "من البداية"
  }
};
export const getBroadcastCopy = () =>
  copy[localizationStrings.getLanguage()] || copy.eng;
